var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDasGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 193 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6816 34.2465C35.224 34.2465 30.01 39.4449 30.01 45.8459V147.154C30.01 153.555 35.224 158.754 41.6816 158.754H143.543C150 158.754 155.214 153.555 155.214 147.154V142.791H92.6121C82.9902 142.791 75.1805 135.037 75.1805 125.445V67.5548C75.1805 57.963 82.9902 50.209 92.6121 50.209H155.214V45.8459C155.214 39.4449 150 34.2465 143.543 34.2465H41.6816ZM155.214 58.9026H92.6121C87.8909 58.9026 84.0046 62.7726 84.0046 67.5548V125.445C84.0046 130.227 87.8909 134.097 92.6121 134.097H155.214V58.9026ZM112.985 99.5C112.985 105.3 117.685 110 123.485 110C129.285 110 133.985 105.3 133.985 99.5C133.985 93.7 129.285 89 123.485 89C117.685 89 112.985 93.7 112.985 99.5ZM139.214 98.5C139.214 97.3954 138.118 96.5 136.785 96.5C135.452 96.5 134.356 97.3954 134.356 98.5C134.356 99.6046 135.452 100.5 136.785 100.5C138.118 100.5 139.214 99.6046 139.214 98.5Z",
    fill: "#3F9339"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDasGreen);
export default __webpack_public_path__ + "static/media/das-green.beb9b93d6a4c07ff92b1e6846ea05268.svg";
export { ForwardRef as ReactComponent };